import React from "react";

import "./repeater.css";

const Repeater = props => (
  <div className="repeater-wrapper">{props.children}</div>
);

export default Repeater;



// WEBPACK FOOTER //
// ./src/system/fields/Repeater/index.jsx